import React from 'react';
import { Button } from '@mui/material';
import { SaveIcon } from 'assets';

interface SubmitButtonProps {
    isLoading: boolean;
    onClick: () => void;
}

export const SubmitButton = ({ isLoading, onClick }: SubmitButtonProps) => (
    <Button
        sx={{ width: 'fit-content', padding: '6px 17px', height: '36px', borderRadius: 2 }}
        variant="contained"
        startIcon={<SaveIcon />}
        onClick={onClick}
        disabled={isLoading}
    >
        {isLoading ? 'Saving...' : 'Save and Continue'}
    </Button>
);